import React from 'react';

import { LoadingIndicator, Text, VStack } from '../../core-ui';
import { useNavigation, useParams } from '../Navigation';
import { VendorDetailsView } from '../VendorList/VendorDetails';
import { useAuthState } from '../AuthState';
import { toMap } from '../../support/helpers/toMap';
import IndexedList from '../../support/shared/IndexedList';

import { useQueryVendorDetails, useSaveVendor } from './api';
import SignupFormModel from '../FormBuilder/SignupFormModel';
import { is404 } from '../../support/useFetch';

export function VendorDetailsPage() {
  const params = useParams();
  const vendorId = params.id ?? '';
  const { account, user } = useAuthState();
  const { backTo } = useNavigation();

  const { data, error, isLoading, refetchAll } = useQueryVendorDetails(
    vendorId,
  );
  const [saveVendor, { isLoading: isSaving }] = useSaveVendor(vendorId);

  if (error && !is404(error)) {
    return <Text>{String(error)}</Text>;
  }

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data) {
    // TODO: Make a Not Found component
    return <Text>{t('Not Found')}</Text>;
  }
  const { vendor, addons, markets, formDef, priceTiers, tags } = data;

  return (
    <VStack
      alignItems="stretch"
      flex={1}
      minH={0}
      padding={7}
      backgroundColor="#eff3f8"
    >
      <VendorDetailsView
        vendorID={vendorId}
        account={account}
        user={user}
        vendor={vendor}
        addons={toMap(addons)}
        markets={new IndexedList(markets)}
        formDef={new SignupFormModel(formDef)}
        priceTiers={new IndexedList(priceTiers)}
        tags={tags}
        onHide={() => backTo('/vendors')}
        saveVendor={(vendor) => saveVendor(vendor)}
        isLoading={isLoading}
        isSaving={isSaving}
        refetchAll={refetchAll}
      />
    </VStack>
  );
}
